
export default {
  layout: 'clear',
  async asyncData({ $axios, route, error }) {
    try {
      const [{ author, statistics }, activeTariff] = await Promise.all([
        $axios.$get(`/author/${route.params.author}`),
        $axios.$get(`/user/activeTariff/${route.params.author}`),
      ])
      return {
        activeTariff,
        author,
        statistics,
      }
    } catch (err) {
      const statusCode = err.response.data.statusCode
      const message = err.response.data.message
      error({
        statusCode,
        message,
      })
    }
  },
  data() {
    return {
      author: null,
      statistics: null,
    }
  },
  computed: {
    seoAuthorName() {
      if (this.author?.type === 'COMPANY') {
        return this.author.profile.title
          ? `${this.author.profile.title} (@${this.author.username})`
          : `@${this.author?.username}`
      } else if (
        this.author?.profile?.firstName &&
        this.author?.profile?.lastName
      ) {
        return `${this.author?.profile?.firstName} ${this.author?.profile?.lastName} (@${this.author.username})`
      } else if (this.author?.profile?.lastName) {
        return `${this.author?.profile?.lastName} (@${this.author.username})`
      } else if (this.author?.profile?.firstName) {
        return `${this.author?.profile?.firstName} (@${this.author.username})`
      } else {
        return `@${this.author?.username}`
      }
    },
    authorName() {
      if (this.author?.type === 'COMPANY') {
        return this.author?.profile?.title
          ? this.author?.profile?.title
          : this.author?.username
      } else {
        return this.author?.profile?.firstName && this.author?.profile?.lastName
          ? `${this.author?.profile.firstName} ${this.author?.profile.lastName}`
          : this.author?.username
      }
    },
    authorPhone() {
      return this.author?.profile?.contacts?.phone || ' '
    },
    authorEmail() {
      return this.author?.profile?.contacts?.email || ' '
    },
    authorAvatar() {
      return this.author?.profile?.avatar
        ? `//img.megasreda.ru/optimize?src=${this.author.profile.avatar}&size=92&format=jpeg`
        : ' '
    },
    authorAddress() {
      return this.author?.profile?.contacts?.address || ' '
    },
    authorSite() {
      return this.author?.profile?.contacts?.website || ' '
    },
    authorSocial() {
      const urls = []
      if (this.author?.profile?.contacts?.vk) {
        urls.push(this.author.profile.contacts.vk)
      }
      if (this.author?.profile?.contacts?.youtube) {
        urls.push(this.author.profile.contacts.youtube)
      }
      if (this.author?.profile?.contacts?.instagram) {
        urls.push(this.author.profile.contacts.instagram)
      }
      if (this.author?.profile?.contacts?.telegram) {
        urls.push(this.author.profile.contacts.telegram)
      }
      if (this.author?.profile?.contacts?.twitter) {
        urls.push(this.author.profile.contacts.twitter)
      }
      if (this.author?.profile?.contacts?.yandexzen) {
        urls.push(this.author.profile.contacts.yandexzen)
      }
      if (this.author?.profile?.contacts?.facebook) {
        urls.push(this.author.profile.contacts.facebook)
      }
      if (this.author?.profile?.contacts?.facebook) {
        urls.push(this.author.profile.contacts.facebook)
      }

      return urls
    },
  },
  created() {
    if (process?.client) {
      this.$eventBus.$on('publish-recommendation', () => this.fetchAuthor())
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('publish-recommendation')
  },
  jsonld() {
    return {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: this.authorName,
      telephone: this.authorPhone,
      email: this.authorEmail,
      image: this.authorAvatar,
      address: this.authorAddress,
      url: this.authorSite,
      sameAs: this.authorSocial,
    }
  },
  methods: {
    async fetchAuthor() {
      const { author, statistics } = await this.$axios.$get(
        `/author/${this.$route.params.author}`
      )
      this.author = author
      this.statistics = statistics
    },
  },
}
